<template>
<div id="content" class="content" style="margin-left:0px;">
	<h1 class="page-header" style="text-align:left">
   修改密码

    </h1>
	<!-- end col-6 -->
	<div id="page-container" class="in page-sidebar-fixed page-header-fixed" style="padding-top:0px;">

	   		<div class="panel panel-inverse" data-sortable-id="form-stuff-10">
						<!-- begin panel-heading -->
						<div class="panel-heading">
							<div class="panel-heading-btn">
								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-default" data-click="panel-expand"><i class="fa fa-expand"></i></a>
								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-success" data-click="panel-reload"><i class="fa fa-redo"></i></a>
								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-warning" data-click="panel-collapse"><i class="fa fa-minus"></i></a>
								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-danger" data-click="panel-remove"><i class="fa fa-times"></i></a>
							</div>
							<h4 class="panel-title">修改密码</h4>
						</div>
						<!-- end panel-heading -->
						<!-- begin panel-body -->
						<div class="panel-body">
							<form >
								<fieldset>
									<div class="form-group row m-b-15">
										<label class="col-md-3 col-form-label">账户名</label>
										<div class="col-md-7">
											<input type="text" class="form-control" placeholder="账户名" v-model="userName" :disabled="disabled"/>
										</div>
									</div>
									<div class="form-group row m-b-15">
										<label class="col-md-3 col-form-label">新密码</label>
										<div class="col-md-7">
											<input type="password" class="form-control" placeholder="新密码" v-model="newPassword"/>
										</div>
									</div>
									<div class="form-group row">
										<div class="col-md-7 offset-md-3">
											   <div class="btn btn-primary m-r-5" @click="MakeSure">确认修改</div>
											   <div class="btn btn-default" @click="resetpassword">重置</div>
										</div>
									</div>
								</fieldset>
							</form>

						</div>
						<!-- end panel-body -->
					</div>

	</div>

</div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";
import MethodsBus from "@/common/methodBus";
import eventBus from "@/common/eventBus";

export default {
  name: 'ChangePassword',
  data () {
    return {
		disabled: true,
		userName: '',
		newPassword: '',
		placeholder:"请输入",

    }
  },
   mounted: function() {
		  if(localStorage.getItem('userName')){
             this.userName = JSON.parse(localStorage.getItem('userName')).userName
			 }
			 this.getRoles();
 },
 methods:{
	resetpassword(){
	    if(this.disabled){
			this.newPassword = '';
		}else{
			this.newPassword = '';
			this.userName = '';
		}

	},
	 getRoles(){
      let that = this;
          const options = {
            url: "user/roles/selectLoginRoles",
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded",'X-Requested-With': 'XMLHttpRequest',"Access-Control-Allow-Origin":"*" },
             data: Qs.stringify({


            })
          };
          axios(options)
            .then(function(response) {
              if (response.data.code == 200) {

                response.data.data.forEach(element => {
					if(element.roleId === 10000){
						that.disabled = false;
					}
				});




              } else {
                 that.ErrorMessage = response.data.message;


              }


            })
            .catch(error => {
              http.handleHttpError(error, that);
            });
     },
	MakeSure(){
	      var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
        if(!reg.test(this.newPassword)) {
          this.$notify({
            title: "警告",
            message: '请输入8~16位以上英文+数字组合',
            type: "warning"
          })
          return
        }

        let that = this;
          const options = {
            url: "user/UserController/resetPwd",
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded",'X-Requested-With': 'XMLHttpRequest',"Access-Control-Allow-Origin":"*" },
             data: Qs.stringify({
              userName: that.userName,
              password : that.newPassword,

            })
          };
          axios(options)
            .then(function(response) {

             if (response.data.code == 200) {

                that.$notify({
                  title: "成功",
                  message: response.data.message,
                  type: "success"
                });

              } else {

                 http.handleEorrorCode(response,that);
              }


            })
            .catch(error => {
              http.handleHttpError(error, that);
            });
	},
	getdata(val){

	},
	getsearchdata(val){

	},
	getpaginationdata(val){

	}
 }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EssentialInformation/ChangePassword.vue